// extracted by mini-css-extract-plugin
export default {"readOnlyText":"style_readOnlyText__3B0iV","readOnlyList":"style_readOnlyList__3jl61","readOnlyListText":"style_readOnlyListText__CMo54"};